import * as d3 from 'd3';

export const isLight = (color: string) => {
  return d3.hsl(color).l >= 0.55;
};
